/* eslint-disable no-undef */

const { default: TpxContentAndAd } = require('./TpxContentAndAd');
const { logDebugging } = require('./log/logger');

module.exports = {
  init(config) {
    window.tpx_players = window.tpx_players || [];
    const tappxContainer = document.querySelector(`#${config.targetId}`);

    if (tappxContainer) {
      this.loadPlayer(config);
    } else {
      logDebugging('no hay contenedor asignado al player');
    }
  },

  async loadPlayer(config) {
    this.loadLibraryYoutube();

    const player = new TpxContentAndAd(config);
    player.init();
    window.tpx_players.push(player);
  },

  loadLibraryYoutube() {
    const tag = document.createElement('script');
    tag.setAttribute('async', true);
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      logDebugging('YOUTUBE CARGADO INDEX.JS');
    };
  },

  getPlayer(targetId) {
    return window.tpx_players.filter((item) => item.config.targetId === targetId)[0];
  },

  onPlayerEvent(targetId, callback) {
    const player = window.tpx_players.filter((item) => item.config.targetId === targetId)[0];
    if (player) {
      player.getEvent().unsubscribe();
      player.getEvent().subscribe((sender, data) => {
        const [event, datos] = data.message;
        callback(sender, event, datos);
      });
    }
  },
  getLinkVideoProducer(targetId) {
    const player = window.tpx_players.filter((item) => item.config.targetId === targetId)[0];
    if (player) {
      return player.player.getLinkVideoProducer();
    }

    return null;
  },
};
